/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClientTermsAndConditionsTarget = {
    Agency: 'AGENCY',
    Freelancer: 'FREELANCER'
} as const;
export type ClientTermsAndConditionsTarget = typeof ClientTermsAndConditionsTarget[keyof typeof ClientTermsAndConditionsTarget];


export function instanceOfClientTermsAndConditionsTarget(value: any): boolean {
    for (const key in ClientTermsAndConditionsTarget) {
        if (Object.prototype.hasOwnProperty.call(ClientTermsAndConditionsTarget, key)) {
            // @ts-ignore
            if (ClientTermsAndConditionsTarget[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClientTermsAndConditionsTargetFromJSON(json: any): ClientTermsAndConditionsTarget {
    return ClientTermsAndConditionsTargetFromJSONTyped(json, false);
}

export function ClientTermsAndConditionsTargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientTermsAndConditionsTarget {
    return json as ClientTermsAndConditionsTarget;
}

export function ClientTermsAndConditionsTargetToJSON(value?: ClientTermsAndConditionsTarget | null): any {
    return value as any;
}

